var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"realization"},[_c('h2',[_vm._v("REALIZATION IS US")]),_c('h3',[_vm._v("HYPER REALISTIC RENDERING")]),_vm._l((10),function(n){return _c('div',{key:n,staticClass:"heart",style:({
      left: n + '0%',
      bottom: Math.random() * 20 + '%',
      animationDuration: Math.random() * 20 + 's',
    })})}),_c('img',{staticClass:"lions",attrs:{"src":"img/main-page/cute-lions.webp","alt":""}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }